import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

import CloseButton from 'components/Buttons/CloseButton/CloseButton';

import './ClosableSection.scss';

const propTypes = {
    children: PropTypes.node,
    showClose: PropTypes.bool,
    onClose: PropTypes.func,
    dataQa: PropTypes.string,
};
const defaultProps = {
    showClose: true,
};
const b = block('ClosableSection');

export default function ClosableSection({children, showClose, onClose, dataQa}) {
    return (
        <div className={b()} data-qa={dataQa}>
            {showClose && <CloseButton className={b('close')} onClick={onClose} />}
            {children}
        </div>
    );
}

ClosableSection.propTypes = propTypes;
ClosableSection.defaultProps = defaultProps;
